import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { TrustStrip } from "@/components/TrustStrip";
import { Services } from "@/components/Services";
import { Intercity } from "@/components/Intercity";
import { ContactCta } from "@/components/ContactCta";
import { Footer } from "@/components/Footer";
import { MobileCtaBar } from "@/components/MobileCtaBar";

// Google Ads için sadeleştirilmiş iniş sayfası: menüsüz header,
// kullanıcıyı siteden uzaklaştıracak bağlantılar en aza indirildi.
export default function CekiciPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="cekici-landing-page">
      <Header minimal />
      <main>
        <Hero />
        <TrustStrip />
        <Services />
        <Intercity />
        <ContactCta />
      </main>
      <Footer />
      <MobileCtaBar />
    </div>
  );
}
